export const CONTACT_PRODUCT_SALES = 'https://www.goto.com/learn-more';

export const supportedLocales = ['de_DE', 'en_US', 'es_ES', 'fr_FR', 'it_IT', 'ja_JP', 'ko_KR', 'pt_BR', 'zh_CN'];

export const THEMES = Object.freeze({
  light: 'LIGHT',
  dark: 'DARK',
});

export const SEARCH_PARAMS = Object.freeze({
  locale: 'locale',
  theme: 'theme',
  partnerType: 'partnerType',
  renewalDate: 'renewalDate',
  redirect: 'redirect',
  baToken: 'ba_token',
});

export const PARTNER_TYPES = Object.freeze({
  parent: 'PARENT',
  child: 'CHILD',
});

export const Roles = Object.freeze({
  systemUser: 'SYSTEM_USER',
});

export const PAYMENT_METHODS_TYPES = Object.freeze({
  cc: 'CREDIT_CARD',
  dd: 'DIRECT_DEBIT',
  ach: 'ACH',
  // razorpay: 'RAZORPAY',
  paypal: 'PAYPAL',
});

export const DD_TYPES = Object.freeze({
  sepa: 'DIRECT_DEBIT_SEPA',
  bacs: 'DIRECT_DEBIT_BACS',
  becs: 'DIRECT_DEBIT_BECS',
  pad: 'DIRECT_DEBIT_PAD',
});

export const PAYMENT_METHODS_TYPES_URL = Object.freeze({
  [PAYMENT_METHODS_TYPES.cc]: 'cc',
  [PAYMENT_METHODS_TYPES.dd]: 'dd',
  [PAYMENT_METHODS_TYPES.ach]: 'ach',
  // 'RAZORPAY',
  [PAYMENT_METHODS_TYPES.paypal]: 'paypal',
});

export const PAYMENT_METHOD_TYPES = Object.freeze({
  [PAYMENT_METHODS_TYPES.cc]: ['CREDIT_CARD', 'CREDIT_CARD_WITH_SCA'],
  [PAYMENT_METHODS_TYPES.dd]: ['DIRECT_DEBIT_SEPA', 'DIRECT_DEBIT_BACS', 'DIRECT_DEBIT_BECS', 'DIRECT_DEBIT_PAD'],
  [PAYMENT_METHODS_TYPES.ach]: ['ACH'],
  [PAYMENT_METHODS_TYPES.paypal]: ['PAYPAL'],
});

export const ONE_PAY_INTENT = Object.freeze({ ...PAYMENT_METHODS_TYPES, addPayment: 'ADD' });

// Credit Card
export const CREDIT_CARD_SAVE = 'CreditCardSave';
export const CREDIT_CARD_ADD_PAY = 'CreditCardAddPay';
export const CREDIT_CARD_NUMBER = 'number';
export const CREDIT_CARD_CVV = 'securityCode';
export const CREDIT_CARD_EXP = 'month-year';
export const CREDIT_CARD_DEFAULT = 'creditCardDefault';

// Direct Debit
export const DD_SEPA_DETAILS = Object.freeze({
  creditorName: 'GOTO TECHNOLOGIES IRELAND UNLIMITED COMPANY',
  creditorIdentifier: 'GB53ZZZSDDBARC0000007495896029',
  paymentType: 'Recurring payment',
  mandateReference: 'LOGMEINIE-ZE23JMSG',
  streetAddress: `77 Sir John Rogerson's Quay Block C, Suite 207 Grand Canal Docklands`,
  city: 'Dublin 2',
  postalCode: 'D02 VK60',
  Country: 'Ireland',
});

export const DD_BACS_DETAILS = Object.freeze({
  creditorName: 'GoTo Technologies UK Limited',
  paymentType: 'Recurring payment',
  sun: '173431',
  streetAddress: '5 New Street Square',
  city: 'London',
  postalCode: 'EC4A 3TW',
  Country: 'United Kingdom',
});

export const DD_BECS_DETAILS = Object.freeze({
  creditorName: 'GoTo Technologies AUS Pty. Ltd.',
  paymentType: 'Recurring payment',
  streetAddress: 'c/o Theunissen Trollip Commercial Lawyer, Level 17 Angel Place, 123 Pitt Street',
  city: 'Sydney NSW',
  postalCode: '2000',
  Country: 'Australia',
});

export const DD_PAD_DETAILS = Object.freeze({
  creditorName: 'GoTo Technologies Canada LTD',
  paymentType: 'Recurring payment',
  streetAddress: '410 Charest Est, Suite 250 Quebec City',
  city: 'QC',
  postalCode: 'G1K 8G3',
  Country: 'Canada',
});

// ACH
export const achAccountTypeList = ['Corporate', 'Checking', 'Savings'];

// Classic pass product families
export const CENTRAL_PRODUCT_FAMILY = 'Central';
export const PRO_PRODUCT_FAMILY = 'Pro';
export const HAMACHI_PRODUCT_FAMILY = 'Hamachi';

export const classicProductFamilyKey: ReadonlyArray<string> = [
  CENTRAL_PRODUCT_FAMILY,
  PRO_PRODUCT_FAMILY,
  HAMACHI_PRODUCT_FAMILY,
];

export const TRACKING_PURCHASE_FLOW = Object.freeze({
  subscription: 'subscription',
  quote: 'quote',
  renewals: 'renewals',
  invoice: 'invoice',
  ecom: 'ecom',
});

export const COPAS_PAYMENT_INTENT = Object.freeze({
  PAYMENT_METHOD_CHANGE_ONLY: 'PaymentMethodChangeOnly',
  PAYMENT_OR_PAYMENT_METHOD_CHANGE: 'PaymentOrPaymentMethodChange',
});

export const COPAS_PAYMENT_STATUS = Object.freeze({
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
});

// This is used across sub-apps - change it everywhere if you change it here
export const TRACKING_EVENT_STATUS = Object.freeze({
  start: 'start',
  click: 'click',
  copasFailure: 'copas failure',
  success: 'success',
});
